import { Skeleton, useTheme } from "@mui/material"
import { tokens } from "../../../theme";

const ShTextSkeleton = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const type = props.type ?? "light";
    const variant = props.variant ?? "grey";
    const palette = props.palette ?? "normal"

    const getBackground = () => {
        if(props.color) {
            return props.color
        }
        if(palette === "pastel") {
            return colors.pastel[type][variant][400];
        }
        if(variant !== "grey") {
            return colors[variant][200];
        } 
        return theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[100]
    }
    const customWaveColor = props.waveColor; // This is a new prop for custom wave color

    return (
        <Skeleton 
            sx={{
                width:1,
                height:props.height ?? 16,
                marginRight:2, 
                bgcolor: getBackground(),
                transform:"none",
                ...(customWaveColor && {
                    '&::after': {
                        // Use the customWaveColor for the gradient
                        // Ensure you're setting a valid CSS value for background
                        background: `linear-gradient(90deg, transparent, ${customWaveColor}, transparent)`,
                    },
                }),
                ...(props.sx && props.sx)
            }} 
            animation="wave"
        ></Skeleton>
    )
}

export default ShTextSkeleton;